export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
export function assertGraphqlVariables(value) {
    if (!isRecord(value))
        throw new Error('FAIL: GraphQL variables must be an object');
    return value;
}
export function parseGraphqlEnvelope(value) {
    if (!isRecord(value))
        throw new Error('FAIL: AppSync response must be an object');
    const errorsValue = value.errors;
    const dataValue = value.data;
    const envelope = {};
    if (dataValue !== undefined) {
        if (!isRecord(dataValue))
            throw new Error('FAIL: AppSync data must be an object');
        envelope.data = dataValue;
    }
    if (errorsValue !== undefined) {
        if (!Array.isArray(errorsValue))
            throw new Error('FAIL: AppSync errors must be an array');
        envelope.errors = errorsValue.map((entry) => {
            if (!isRecord(entry) || typeof entry.message !== 'string') {
                throw new Error('FAIL: AppSync error entries must include a message');
            }
            return { message: entry.message };
        });
    }
    return envelope;
}
export function assertDariceAuthContext(value) {
    if (!value || typeof value.jwt !== 'string' || value.jwt.trim().length === 0) {
        throw new Error('FAIL: GraphQL session requires a JWT');
    }
    if (typeof value.expiresAt !== 'number' || !Number.isFinite(value.expiresAt)) {
        throw new Error('FAIL: GraphQL session requires an expiresAt timestamp');
    }
    if ('sessionCookie' in value && value.sessionCookie !== undefined && value.sessionCookie.trim().length === 0) {
        throw new Error('FAIL: darice-session cookie must not be empty');
    }
    return value;
}
//# sourceMappingURL=dto.js.map